import { disableThumbLogs, thumbLogsParams } from 'reactApp/appHelpers/featuresHelpers/features/thumbLogs';
import { sendDwh } from 'reactApp/utils/ga';

export const enum NoThumbReasons {
    tooSmall = 'small',
    noSize = 'no-size',
    notPreviewable = 'no-preview',
    tooBig = 'big',
}

export const sendThumbDwh = ({ reason, action, dwh }: { reason?: NoThumbReasons; action: string; dwh: Record<string, any> }) => {
    if (disableThumbLogs) {
        return;
    }

    sendDwh({
        eventCategory: 'thumb',
        action,
        dwh_enabled: thumbLogsParams.dwhEnabled,
        dwhData: {
            ...dwh,
            reason,
        },
    });
};

export const getMtimeString = (thumbUrl: string, mtime?: string): string => {
    return mtime ? `${thumbUrl}${thumbUrl.includes('?') ? '&' : '?'}mt=${mtime}` : thumbUrl;
};
